<template>
    <div class="prospus-modal">
        <div ref="refModalContent" class="prospus-modal__content px-0 pt-0">
            <div class="prospus-modal__header px-0 pb-2">
                <slot name="header"></slot>
            </div>
            <div ref="refModalBody" class="prospus-modal__body">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "BaseModal",
    props: {
        variant: {
            type: String,
            default: "prospus-bg-glory-red",
        },
    },
    mounted() {
        const timeoutHandler = setTimeout(() => {
            const modalContent = this.$refs.refModalBody;
            const height = modalContent.clientHeight;
            console.log("modal height : ", height);
            modalContent.style && (modalContent.style.height = `${height}px`);
            clearTimeout(timeoutHandler);
        }, 1000);
    },
};
</script>

<style lang="scss" scoped>
@import "../../../../sass/_theme-variables.sass";

.prospus-modal__content {
    background-color: $section !important;
    overflow: hidden;
}
</style>

<style lang="scss">
/* Apply rounded corners to all VBtns inside any BaseModal */
.prospus-modal .v-btn {
    border-radius: 20px !important;
}
</style>
